<template>
  <div class="ht100-monitor_normal">
    <div class="top" :style="{ '--color': '#009898' }">
      <template v-for="item in list">
        <div class="item" v-if="item.show()" :key="item.prop">
          <span class="label">{{ $t(item.label) }}:</span>
          <span class="value">{{ model[item.prop] ? $t(model[item.prop]) : '--' }}</span>
        </div>
      </template>
    </div>

    <el-tabs v-if="hasMonitoring" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="监控数据" name="monitoring">
        <div class="ht100-monitoring-data">
          <div
            class="ht100-monitoring-data_item"
            v-for="item in monitoringOptions"
            :key="item.prop"
          >
            <span class="ht100-monitoring-data_item-label">{{ item.label }}</span>
            <span class="ht100-monitoring-data_item-value">
              {{ monitoringData[item.prop] }}{{ item.unit || '' }}
            </span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="谱图数据" name="spectrogram">
        <div class="ht100-spectrogram-data">
          <v-chart :options="options" ref="charts" :autoresize="true" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { makeLineOptions } from '../utils/index';

export default {
  inject: ['getRoot'],
  data() {
    return {
      activeName: 'monitoring',
      options: makeLineOptions()
    };
  },
  computed: {
    list() {
      const root = this.getRoot();

      return root.statusOptions;
    },
    model() {
      const root = this.getRoot();

      return root.j218StateData;
    },
    monitoringOptions() {
      const root = this.getRoot();

      return root.monitoringOptions;
    },
    monitoringData() {
      const root = this.getRoot();

      return root.j218Data;
    },
    hasMonitoring() {
      const root = this.getRoot();
      return root.hasMonitoring;
    }
  },
  methods: {
    handleClick(e) {
      this.activeName = e.name;
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.ht100-monitor_normal {
  height: 100%;

  --top-height: 30%;
  --bottom-height: 70%;

  .top {
    --mb: 20px;
    --color: #009898;

    color: var(--color);
    border: 1px solid var(--color);
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(0, 152, 152, 0.08) 0%, rgba(0, 152, 152, 0.02) 100%);

    width: 100%;
    height: calc(var(--top-height) - var(--mb));
    font-size: 24px;

    margin-bottom: var(--mb);

    display: flex;
    justify-content: space-around;
    align-items: center;

    .item {
      font-size: 22px;
      width: 24%;
      text-align: center;
      padding: 12px 8px;
      border-radius: 8px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(0, 152, 152, 0.1);
        transform: translateY(-2px);
      }

      .label {
        margin-right: 8px;
        font-weight: 500;
        opacity: 0.9;
      }

      .value {
        font-weight: 600;
        letter-spacing: 1px;
      }
    }
  }

  .el-tabs {
    height: var(--bottom-height);

    &__header {
      border-bottom: unset !important;
      margin-bottom: unset;
    }

    .el-tabs__nav {
      border: 1px solid #1b3450;
      border-radius: 8px 8px 0 0;
      overflow: hidden;
    }

    .el-tabs__item {
      color: #8ba3c7;
      border: none;
      background: rgba(27, 52, 80, 0.5);
      transition: all 0.3s ease;

      &.is-active {
        color: #009898;
        background: rgba(0, 152, 152, 0.15);
      }

      &:hover {
        color: #00b8b8;
        background: rgba(0, 152, 152, 0.1);
      }
    }

    &__content {
      height: calc(100% - 56px);
      border: 1px solid #1b3450;
      border-top: none;
      border-radius: 0 0 8px 8px;
      overflow: hidden;
    }

    .el-tab-pane {
      height: 100%;

      .ht100-monitoring-data {
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        color: #009898;
        padding: 16px;
        gap: 8px;

        &_item {
          width: calc(25% - 6px);
          display: flex;
          align-items: center;
          gap: 8px;
          justify-content: center;
          padding: 12px 16px;
          border-radius: 6px;
          background: rgba(0, 152, 152, 0.03);
          border: 1px solid rgba(0, 152, 152, 0.1);
          transition: all 0.3s ease;

          &:hover {
            background: rgba(0, 152, 152, 0.08);
            border-color: rgba(0, 152, 152, 0.3);
            transform: translateY(-1px);
          }

          &-label {
            width: 160px;
            text-align: right;
            font-size: 14px;
            opacity: 0.85;

            &::after {
              content: ':';
              margin-left: 4px;
            }
          }

          &-value {
            font-weight: 600;
            font-size: 15px;
            letter-spacing: 0.5px;
          }
        }
      }

      .ht100-spectrogram-data {
        height: 100%;
        padding: 8px;
      }
    }
  }
}
</style>
